// extracted by mini-css-extract-plugin
export default {"sideNavi":"SideNavi_sideNavi__jUS4A","title":"SideNavi_title__FgYAZ"};